<div [ngClass]="data.component">
  @switch (data.component) {
    @case ('about') {
      <app-modal-content-about (closed)="handleClose($event)" />
    }
    @case ('approver-select') {
      <app-modal-content-approver-select [approvers]="data.data.approvers" (closed)="handleClose($event)" />
    }
    @case ('billcode-change') {
      <app-modal-content-bill-code-change
        [current]="data.data.current"
        [selectOptions]="data.data.selectOptions"
        (closed)="handleClose($event)"
      />
    }
    @case ('cats-info') {
      <app-modal-content-cats-info [catsRecord]="data.data" (closed)="handleClose($event)" />
    }
    @case ('confirm') {
      <app-modal-content-confirm
        [questionText]="data.data.questionText"
        [title]="data.data.title"
        [yesText]="data.data.yesText"
        [noText]="data.data.noText"
        (closed)="handleClose($event)"
      />
    }
    @case ('contract-select') {
      <app-modal-content-contract-select
        [headerText]="data.data.headerText"
        [contracts]="data.data.contracts"
        (closed)="handleClose($event)"
      />
    }
    @case ('default-change') {
      <app-modal-content-default-change
        [config]="data.data.config"
        [values]="data.data.values"
        [title]="data.data.title"
        [body]="data.data.body"
        [icon]="data.data.icon"
        [svgIcon]="data.data.svgIcon"
        (default)="handleClose($event)"
      />
    }
    @case ('entity-number-lookup') {
      <app-modal-content-entity-number-lookup [entityType]="data.data.entityLookupType" (closed)="handleClose($event)" />
    }
    @case ('need-help') {
      <app-modal-content-need-help
        [messageSeed]="data.data?.messageSeed"
        [emailAddressOverride]="data.data?.emailAddressOverride"
        [subjectOverride]="data.data?.subjectOverride"
        (closed)="handleClose($event)"
      />
    }
    @case ('nonbillable-select') {
      <app-modal-content-nonbillable-select
        [workScheduleRule]="data.data.workScheduleRule"
        [focusedDay]="data.data.focusedDay"
        [absence]="data.data.absence"
        [attendance]="data.data.attendance"
        (closed)="handleClose($event)"
      />
    }
    @case ('simple-text') {
      <app-modal-content-simple-text
        [title]="data.data.title"
        [body]="data.data.body"
        [icon]="data.data.icon"
        [svgIcon]="data.data.svgIcon"
        [buttonText]="data.data.buttonText"
        [buttonAction]="data.data.buttonAction"
        [webpageUrl]="data.data.webpageUrl"
        (closed)="handleClose($event)"
      />
    }
    @case ('spinner') {
      <mat-spinner />
    }
    @case ('split') {
      <app-modal-content-split-modal [pool]="data.data.pool" (split)="handleClose($event)" />
    }
    @case ('time-eval') {
      <app-modal-content-time-eval [employee]="data.data.employee" (closed)="handleClose($event)" />
    }
    @case ('timesheet-create-or-edit') {
      <app-modal-content-timesheet-create-or-edit
        [record]="data.data.record"
        [productionGroup]="data.data.productionGroup"
        [allExtDocuments]="data.data.allExtDocuments"
        [applicableExtDocuments]="data.data.applicableExtDocuments"
        [headerConfigs]="data.data.headerConfigs"
        [existingDescription]="data.data.existingDescription"
        [selectedCostCenterCondGrpTabs]="data.data.selectedCostCenterCondGrpTabs"
        (closed)="handleClose($event)"
      />
    }
    @case ('timesheet-move') {
      <app-modal-content-timesheet-move
        [record]="data.data.record"
        [productionGroup]="data.data.productionGroup"
        [timesheet]="data.data.timesheet"
        (closed)="handleClose($event)"
      />
    }
    @case ('timesheet-select') {
      <app-modal-content-timesheet-select
        [handler]="data.data.handler"
        [step]="data.data.step"
        [contract]="data.data.contract"
        [timesheets]="data.data.timesheets"
        (closed)="handleClose($event)"
      />
    }
    @case ('vertical-bulk-add-per-diem') {
      <app-modal-content-vertical-bulk-add-per-diem
        [employeesCount]="data.data.employeesCount"
        [formattedDate]="data.data.formattedDate"
        [costCenter]="data.data.costCenter"
        (closed)="handleClose($event)"
      />
    }
    @case ('per-diem-totals') {
      <app-modal-content-per-diem-totals [employeeInfo]="data.data.employeeInfo" (closed)="handleClose($event)" />
    }
  }
</div>

<!-- Put the close X button last so that it isn't auto-focused when the modal is opened -->
<button mat-icon-button mat-dialog-close aria-label="Close" (click)="handleClose()"><mat-icon>close</mat-icon></button>
